import vue from 'vue'
import AvatarCropper from './AvatarCropper'
import store from '@/store/index'
const AvatarCropperCreater = vue.extend(AvatarCropper)
let avatarCropperInstance

export default {
  open (imgSrc, file) {
    return new Promise((resolve, reject) => {
      if (avatarCropperInstance) {
        avatarCropperInstance = null
      }
      let currentdiv = document.createElement('div')
      currentdiv.id = 'avatarCropperInstance'
      document.body.appendChild(currentdiv)
      avatarCropperInstance = new AvatarCropperCreater({
        data () {
          return {
            visible: true,
            imgSrc: imgSrc,
            file: file,
            resolve: resolve,
            reject: reject
          }
        },
        store,
      }).$mount('#avatarCropperInstance')
    })
  },
  close () {
    if (!avatarCropperInstance) return 
    avatarCropperInstance.visible = false
  }
}